import { useLocation } from "react-router-dom";

const Navigation = () => {

  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div className="app-sidebar colored">
      <div className="sidebar-header">
        <a className="header-brand" href="/">
          {/* <div className="logo-img">
            <img src="images/fullLogoWhite.png" height={50} className="header-brand-img" alt="dixxip" /> 
          </div> */}
          <span className="text-secondary">reboot</span>
        </a>
        {/* <button type="button" className="nav-toggle"><i data-toggle="expanded" className="ik ik-toggle-right toggle-icon" /></button> */}
        <button id="sidebarClose" className="nav-close"><i className="ik ik-x" /></button>
      </div>
      <div className="sidebar-content">
        <div className="nav-container">
          <nav id="main-menu-navigation" className="navigation-main">
            <div className="nav-lavel">Navigation</div>
            <div className={`nav-item${isActive("/") ? " active" : ""}`}>
              <a href="/"><i className="ik ik-bar-chart-2" /><span>Dashboard</span></a>
            </div>
            <div className={`nav-item${isActive("/statistiche") ? " active" : ""}`}>
              <a href="/statistiche"><i className="ik ik-pie-chart" /><span>Statistiche</span></a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}
export default Navigation;